module.exports = __webpack_public_path__ + "img/logo.7b91abd3.png";